import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { first, map } from 'rxjs/operators';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';
import { OrderModel } from '../models/order.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/fire/database";
var OrderService = /** @class */ (function () {
    function OrderService(http, afd) {
        this.http = http;
        this.afd = afd;
        this.api = environment.apiURL;
    }
    /**
     * Get prices based on customer request
     * @param data - reqest data
     * @returns {Promise<any>} return results as promise
     */
    OrderService.prototype.getPrices = function (data) {
        return this.http.post(this.api + '/order/prices', data).pipe(first()).toPromise();
    };
    /**
     * Place an order
     * @param order - order object
     * @returns {Promise<firebase.database.DataSnapshot>} return data snapshot as response
     */
    OrderService.prototype.placeOrder = function (order) {
        return this.afd.database.ref('orders').push(order).once('value');
    };
    /**
     * Get order information
     * @param {string} orderId - order id
     * @returns {Observable<OrderModel>} -
     */
    OrderService.prototype.getOrderInfo = function (orderId) {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.afd.object('orders/' + orderId).valueChanges()
                .subscribe(function (res) {
                var order = res;
                order['id'] = orderId;
                subscriber.next(new OrderModel(order));
            });
        });
    };
    /**
     * Update order information
     * @param {string} orderId - order id
     * @param updates - updates
     * @returns {Promise<any>} return response as promise
     */
    OrderService.prototype.updateOrder = function (orderId, updates) {
        return this.afd.object('orders/' + orderId).update(updates);
    };
    /**
     * Get customers orders
     * @param {string} customerID - customer id
     * @returns {Observable<Array<OrderModel>>} - return an array of orders as observable
     */
    OrderService.prototype.getCustomersOrders = function (customerID) {
        return this.afd.list('orders/', function (ref) { return ref.orderByChild('customerID').equalTo(customerID); })
            .snapshotChanges()
            .pipe(map(function (snapshots) {
            var orders = [];
            for (var _i = 0, snapshots_1 = snapshots; _i < snapshots_1.length; _i++) {
                var snapshot = snapshots_1[_i];
                var order = snapshot.payload.val();
                order['id'] = snapshot.key;
                orders.unshift(new OrderModel(order));
            }
            return orders;
        }));
    };
    /**
     * Get available coverage for delivery
     */
    OrderService.prototype.getCoverage = function () {
        return this.afd.object('/coverage').snapshotChanges()
            .pipe(first())
            .pipe(map(function (snapshot) {
            return snapshot.payload.val();
        }))
            .toPromise();
    };
    OrderService.ngInjectableDef = i0.defineInjectable({ factory: function OrderService_Factory() { return new OrderService(i0.inject(i1.HttpClient), i0.inject(i2.AngularFireDatabase)); }, token: OrderService, providedIn: "root" });
    return OrderService;
}());
export { OrderService };
